import { getPurchaseGlobalHref } from "app/common/hrefs";
import { swSettings } from "app/common/services/swSettings";
import createSiTrackingEventName from "app/common/utils/createSiTrackingEventName";
import { openHooksModalV4, openHooksModalV5, openHooksModalV6 } from "app/services/ModalService";
import { EHooksVersions } from "app/services/SwHook";
import { allTrackers } from "app/services/track/track";
import { goToPackagesPage } from "app/UtilitiesAndConstants/UtilityFunctions/goToPackagesPage";
import { getPurchasePageHref } from "app/UtilitiesAndConstants/UtilityFunctions/goToPurchasePage";
import { isSI } from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";

interface IPlainObject {
    [key: PropertyKey]: any;
}

interface IPurchasePageParams extends IPlainObject {
    currency: string;
    package: string;
    period: string;
    workspace: string;
    promo?: boolean | string;
}

export enum TestCases {
    TRIAL = "trial",
    TRIAL_AFTER_TRIAL = "trial_after_trial",
}

export const handleGainAccessRedirect = (
    eventName: string,
    action: string,
    eventCategory: string,
    eventSubName?: string,
    eventSubSubName?: string,
    hook?: string,
) => {
    const trackerName = createSiTrackingEventName(eventName, eventSubName, eventSubSubName);
    allTrackers.dispatchTrackEvent(eventCategory, action, trackerName);
    goToPackagesPage({ hook: hook });
};

const handleAccessRedirect = (urlParams: IPurchasePageParams): string => {
    const url = getPurchasePageHref({ ...urlParams });
    window.open(url);

    return url;
};

const getPremiumSalesPurchaseParams = (urlParams: IPlainObject = {}): IPurchasePageParams => ({
    currency: "USD",
    package: "PremiumSalesExtension",
    period: "annually",
    promo: "",
    workspace: "sales",
    ...urlParams,
});

const getTrackedPurchaseUrl = (purchaseParams: IPurchasePageParams): string => {
    const params = new URLSearchParams(purchaseParams).toString();
    const urlWithoutReturnUrl = params ? `${getPurchaseGlobalHref()}?${params}` : getPurchaseGlobalHref();

    return urlWithoutReturnUrl.split("/").slice(-2).join(" ");
};

export const handlePremiumSalesAccessRedirectWithTracking = (
    eventName: string,
    urlParams: IPlainObject = {},
): string => {
    const purchaseParams = getPremiumSalesPurchaseParams(urlParams);
    const url = handleAccessRedirect(purchaseParams);

    const trackedURL = getTrackedPurchaseUrl(purchaseParams);

    const trackerName = createSiTrackingEventName(eventName, trackedURL);
    allTrackers.dispatchTrackEvent("sales intelligence hooks", "click", trackerName);

    return url;
};

export const handleCTAClick = async (
    version: EHooksVersions,
    hook: string,
    test: TestCases,
    location?: string,
    overrideTrackingKey?: string,
) => {
    const suffix = isSI(swSettings) ? "SIRedirect" : "";
    switch (version) {
        case EHooksVersions.V4:
            return await openHooksModalV4(`${hook}${suffix}`, location, overrideTrackingKey);
        case EHooksVersions.V5:
            return await openHooksModalV5(`${hook}${suffix}`, location, overrideTrackingKey);
        case EHooksVersions.V6:
            return await openHooksModalV6(`${hook}${suffix}`, location, overrideTrackingKey);
    }
};
